import { DatePipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbActiveModal, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbModal, NgbModalRef, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from '@spartacus/core';
import moment from 'moment';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { AcceptBidModalComponent } from '../accept-bid-modal/accept-bid-modal.component';
import * as uuid from 'uuid';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import {restrictDecimaNumberDirective} from 'src/app/shared/components/two-digit-decima-number.directive';
import { CustomAdapterRecordPickup, CustomDateParserFormatter, DateRangePickerI18nService } from '../../services/date-range-picker-i18n.service';
import { restrictDecimaNumberDirective as restrictDecimaNumberDirective_1 } from '../two-digit-decima-number.directive';

@Component({
    selector: 'app-record-pickup-modal',
    templateUrl: './record-pickup-modal.component.html',
    styleUrls: ['./record-pickup-modal.component.scss'],
    providers: [{ provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService }, { provide: NgbDateAdapter, useClass: CustomAdapterRecordPickup },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
    imports: [FormsModule, ReactiveFormsModule, NgFor, restrictDecimaNumberDirective_1, NgbInputDatepicker, NgIf]
})
export class RecordPickupModalComponent implements OnInit {
  @Input() recordData: any;
  @Input() quoteData: any;
  @ViewChild('acceptModal') private modalContent: TemplateRef<AcceptBidModalComponent>;
  gaugeTitleForm: UntypedFormGroup;
  gaugeTitles: UntypedFormArray;
  private modalRef: NgbModalRef;
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD-MM-YYYY',
    icons: 'font-awesome',
    singleCalendar: true,
    minDate: moment().subtract(0, 'day'),
    maxDate: moment().add(1, 'year'),
    validators: Validators.required,
  };
  timeSelected: any;
  timeStart = 0; // start time in hours;
  timeEnd = 24; // end time in hours;
  timeInterval = 10; // interval in min;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  timeArray = [];
  startDate: NgbDate = null;
  endDate: any = null;
  datePipe = new DatePipe('en-US');
  showDateError = false;
  form: UntypedFormGroup;
  counterOfferError = false;
  counterOfferErrorValue = '';
  selectedDate: any;
  dateSelected: any;
  myForm: any;
  responseData: any;
  singleFieldOptions: IDateRangePickerOptions = {
    autoApply: true,
    clickOutsideAllowed: false,
    // format: 'MM/DD/YYYY',
    format: 'DD-MM-YYYY',
    // icons: 'material',
    labelText: 'Single Picker',
    minDate: moment().subtract(2, 'years'),
    maxDate: moment().add(1, 'year'),
    singleCalendar: true,
  }
  constructor(private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal, public cd:ChangeDetectorRef,
    private inventoryManagementService: InventoryManagementService, private toastService: ToastService,
    public router: Router,formatter: NgbDateParserFormatter
   ) {
    //  console.log("Record pickup data:" + this.recordData);
    }

  ngOnInit(): void {
    console.log("Record pickup data:" + this.recordData);
    console.log("quote data:" + this.quoteData);
    this.gaugeTitleForm = this.formBuilder.group({
      // gaugeTitles: this.formBuilder.array([this.createItem()])
      gaugeTitles: this.formBuilder.array([])
    });
    const momentObj = moment();
    //this.startDate = momentObj.toDate();
    this.dateSelected = momentObj.format('DD-MM-YYYY');
    for (let i = this.timeStart; i <= this.timeEnd; i++) {
      const timeString = ('0' + i).slice(-2);
      const timeStringWith0 = timeString + ':00';
      const halfTimeString = timeString + ':30';
      if (halfTimeString !== '24:30'){
        this.timeArray.push(timeStringWith0);
        this.timeArray.push(halfTimeString);
      }
    }

    //sample data
    // this.responseData = {
    //   "quoteEntry": "String",
    //   "quoteRecordPickUpEntries": [{
    //       "dateCollected": "21-06-2022",
    //       "quantityCollected": 55
    //     },
    //     {
    //       "dateCollected": "21-07-2022",
    //       "quantityCollected": 13
    //     },
    //     {
    //       "dateCollected": "21-08-2022",
    //       "quantityCollected": 98
    //     }
    //   ]
    // }
    this.responseData = this.recordData;

    if(this.responseData && this.responseData["quoteRecordPickUpEntries"] && this.responseData["quoteRecordPickUpEntries"].length>0){
      // this.responseData["quoteRecordPickUpEntries"].map((value: any)=>{
        for(let i=0;i<this.responseData["quoteRecordPickUpEntries"].length;i++){
        this.gaugeTitles = this.gaugeTitleForm.get('gaugeTitles') as UntypedFormArray;
        this.gaugeTitles.push(this.formBuilder.group({
          name: [this.responseData["quoteRecordPickUpEntries"][i]["quantityCollected"], Validators.required],
          secondDateRange: [this.responseData["quoteRecordPickUpEntries"][i]["dateCollected"],Validators.required]}));
        // this.gaugeTitles.value.secondDateRange = this.gaugeTitles.value.name0
        // let a = this.gaugeTitleForm.get('gaugeTitles')['controls'];
        // console.log("a",a)
      // })
        }
    }else{
      //else condition
      this.gaugeTitles = this.gaugeTitleForm.get('gaugeTitles') as UntypedFormArray;
      this.gaugeTitles.push(this.createItem());
    }
    //assigning dates
    setTimeout(()=>{
      if(this.responseData && this.responseData["quoteRecordPickUpEntries"] && this.responseData["quoteRecordPickUpEntries"].length> 0){
        this.assigningDates();
      }
    },1000)
  }
  //assigning dates
  assigningDates(): any {
      for(let i=0;i<this.gaugeTitleForm.get('gaugeTitles')['controls'].length;i++){
        // this.gaugeTitleForm.value["gaugeTitles"][i].secondDateRange = this.gaugeTitles.value[i]['name' + i]
        this.gaugeTitleForm.value["gaugeTitles"][i].secondDateRange = this.responseData["quoteRecordPickUpEntries"][i]["dateCollected"]
        this.gaugeTitleForm.value["gaugeTitles"][i].name = this.responseData["quoteRecordPickUpEntries"][i]["quantityCollected"]
      }
      this.cd.detectChanges();
  }

  detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

  createItem(): any {
    console.log("device specific", navigator.userAgent);
    const isMobile = this.detectMob();
    console.log("is mobile", isMobile);
    if(isMobile) {
      const currDate = new Date().toLocaleDateString().split("/");
      const thisDay = currDate[0] + "-" + currDate[1] + "-" + currDate[2];
      return this.formBuilder.group({
        name: [0, Validators.required],
        secondDateRange: [thisDay,Validators.required]
      });
    }else{
      const currDate = new Date().toLocaleDateString().split("/");
      const thisDay = currDate[1] + "-" + currDate[0] + "-" + currDate[2];
      return this.formBuilder.group({
        name: [0, Validators.required],
        secondDateRange: [thisDay,Validators.required]
      });
    }
  }
  addItem(): void{
    if(!this.gaugeTitleForm.invalid){
      
    }
    this.gaugeTitles = this.gaugeTitleForm.get('gaugeTitles') as UntypedFormArray;
    this.gaugeTitles.push(this.createItem());
    let a = this.gaugeTitleForm.get('gaugeTitles')['controls'];
    console.log("total gauge titles", a);
  }
  // tslint:disable-next-line:typedef
  removeRow(index) {
    console.log(index);
    (this.gaugeTitleForm.get('gaugeTitles') as UntypedFormArray).removeAt(index);
  }
  selectTimeFunction(): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
  }

  onRangeSelected(value: IDateRange): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.firstFieldEmittedValue = value;
    //this.startDate = this.firstFieldEmittedValue.start.toDate();
    // this.filterData();
  }
  onDateSelection(selectedDate){
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.startDate = selectedDate
  }
  changeDateFormat(dateString:string){
    let DateArray=dateString.split('-');
    return DateArray[0]+'/'+DateArray[1]+'/'+DateArray[2];
  }
  onReset(event: any): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    if (event !== undefined) {
      this.dateRangePicker.reset(event);
      this.dateRangePicker.toggleCalendarVisibility(false);
    }
      //  this.dateRangePicker.toggleCalendarVisibility(false);
      // event.preventDefault();
      // event.stopPropagation();
    this.showDateError = false;
    this.startDate = null;

    }

    // tslint:disable-next-line:typedef
    onSubmit(){
      for(var i=0;i<this.gaugeTitleForm.get('gaugeTitles')['controls'].length;i++){
        if(this.gaugeTitles.value[i]['name' + i]){
          this.gaugeTitleForm.value["gaugeTitles"][i].secondDateRange = this.gaugeTitles.value[i]['name' + i]
        }
      }
      let datesData: [];
      const request = {
        // "batchId": this.quoteData.PLbatch,
        // "contractNumber": this.quoteData.CTContract,
        "batchId": this.quoteData.batchNumber,
        "contractNumber": this.quoteData.contractNumber,
        "nominationItemRecordPickUpEntryRequest": []
        // "quoteRecordPickUpEntryRequest": [
        //   {
        //     "dateCollected": "12-12-2021",
        //     "quantityCollected": 11
        //   }
        // ]
      }
      // request["quoteRecordPickUpEntryRequest"] = this.gaugeTitleForm.value;
      console.log(request);
      this.gaugeTitleForm.value.gaugeTitles.map((val: any)=>{
        request["nominationItemRecordPickUpEntryRequest"].push({
          dateCollected: val.secondDateRange,
          quantityCollected: val.name
        })
      });
      console.log("sample request :"+ request)
      this.inventoryManagementService.saveRecordPickupDetails(request).subscribe((resp: any)=>{
        console.log("response:" + resp)
        if(resp && resp.status && resp.status === 'Record pickup updated successfully'){
          this.toastService.show(resp.status);
          setTimeout(()=>{
            window.location.reload();
          },1000)
          this.activeModal.dismiss('close click')
        }else if(resp && resp.status && resp.status === 'Record pickup updation failed'){
          this.toastService.show(resp.status);
          // this.activeModal.dismiss('close click')
        }else{
          this.toastService.show(resp.status?resp.status: "Something went wrong!");
          // this.activeModal.dismiss('close click')
        }
      })
      // console.log(this.gaugeTitleForm.value);
    }


    quantityValidation($event){
      // tslint:disable-next-line:prefer-const
      let s = $event.target.value.split('.');
      if (s.length === 1){
        if (s[0].length >= 6) {
          $event.preventDefault();
        }
      }
    }

}
